import { Checkbox, Form } from 'antd';
import Text from 'components/Text/Text';
import React from 'react';
import style from './CutoverCheckbox.module.scss';

interface ICutoverCheckbox {
	isCutoverBeforeUpdate: boolean;
	toggleCutoverBeforeUpdate: () => void;
}

const CutoverCheckbox: React.FC<ICutoverCheckbox> = ({ isCutoverBeforeUpdate, toggleCutoverBeforeUpdate }) => {
	return (
		<Form.Item name="isCutoverBeforeUpdate">
			<Checkbox
				data-test="CutoverCheckbox"
				className={style.checkbox}
				checked={isCutoverBeforeUpdate}
				onChange={toggleCutoverBeforeUpdate}>
				<Text translationNameSpace="form" translationKey="cutoverBeforeUpdateLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
};

export default React.memo(CutoverCheckbox);
